/**
 * Breadcrumb JS
 */
import $ from 'jquery';

Drupal.behaviors.breadcrumb = {
  attach() {
    $('.breadcrumb').map((idx, breadcrumb) => {
      if ($(window).width() > 480) {
        // let breadcrumb = $(breadcrumb);
        if (breadcrumb.children().length >= 5) {
          const detachedChildren = breadcrumb
            .children()
            .slice(2, -1)
            .detach();
          const expandBreadcrumb = $(
            '<li><svg class="fill-current h-4 w-4 mx-2  svg"><use xlink:href="images/spritemap.svg#chevronRight"></use></svg><a class="dotitem ml-1 mr-2" href="" title="Show all breadcrumbs"><strong>. ' +
              '. ' +
              '.</strong></a><span class="dotitemwrap"></span></li>'
          );
          $(document).on('click', (event) => {
            const $trigger = $('.breadcrumb');
            if ($trigger !== event.target && !$trigger.has(event.target).length) {
              $('.dotitemwrap').removeClass('active');
              $('.dotitemwrap')
                .parents('li')
                .removeClass('activedot');
            }
          });
          expandBreadcrumb.on('click', (event) => {
            event.preventDefault();
            $('.dotitemwrap').append(detachedChildren);
            $('.dotitemwrap').toggleClass('active');
            $('.dotitemwrap')
              .parents('li')
              .toggleClass('activedot');
          });
          breadcrumb
            .children()
            .last()
            .before(expandBreadcrumb);
        }
      } else {
        // let breadcrumb = $(breadcrumb);
        const detachedChildren = breadcrumb
          .children()
          .slice(1, -1)
          .detach();
        const expandBreadcrumb = $(
          '<li><svg class="fill-current h-4 w-4 mx-2.5  svg"><use xlink:href="images/spritemap.svg#chevronRight"></use></svg><a class="dotitem ml-1 mr-2" href="" title="Show all breadcrumbs"><strong>. ' +
            '. ' +
            '.</strong></a><span class="dotitemwrap"></span></li>'
        );
        expandBreadcrumb.on('click', (event) => {
          event.preventDefault();
          $('.dotitemwrap').append(detachedChildren);
          $('.dotitemwrap').toggleClass('active');
          $('.dotitemwrap')
            .parents('li')
            .toggleClass('activedot');
        });
        breadcrumb
          .children()
          .last()
          .before(expandBreadcrumb);
      }

      return idx;
    });
  },
};
